// src/components/ParallaxSection.jsx
import React from 'react';

const ParallaxSection = ({ imageUrl, height = 'h-[180vh]', children }) => {
  return (
    <div
      className={`relative bg-fixed bg-center bg-cover ${height} flex items-center justify-center`}
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
     <div className="w-full h-full bg-black bg-opacity-50 flex items-center justify-center">
  {children}
</div>

    </div>
  );
};

export default ParallaxSection;
